import React, { useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import { GlobalContext } from "../../../Renderers/GlobalContext";

const Toolbar = ({
  disabled, onSave, onDelete, onReset, onNameChange, name, type, hasSpChars, placeholder
}) => {

  const { organization } = useContext(GlobalContext).state
  const { t, i18n } = useTranslation([
    "portal/menu_items"
  ], {
    useSuspense: false
  })

  useEffect(() => {
    // i18n.changeLanguage(organization.platformLanguage)
  }, [])

  function save(e) {
    e.target.disabled = true;
    onSave(e);
  }

  function handleChange(e) {
    onNameChange(e)
  }

  return (
    <>
      <div className="d-flex align-items-center section-header-box bg-2 ps-2">
        <div className="bigger flex-grow-1">
          {t("edit_form.title")}
        </div>
        <div className="flex-grow-1 text-end">
          <button title="Save" className="btn btn-primary" onClick={save} type="submit" disabled={disabled}><i className="fas fa-save mx-1"></i>{t("edit_form.buttons.save_button_label")}</button>
          <button title="Delete" className="btn btn-secondary mx-2" onClick={onDelete} type="button"><i className="fas fa-times"></i></button>
          <button title="Revert changes" className="btn btn-secondary " onClick={onReset} type="button"><span className="k-icon k-i-undo pb-1"></span></button>
        </div>
      </div>
      <div className="border-bottom ps-2 row me-0">
        {/* <div className="form-label">{type}</div> */}
        <div className="col-md-6 col-lg-4 mb-4" >
          <div className="form-label">
            {t("edit_form.menu_item_name_field_label")}
            <span className="ms-2 error">{hasSpChars && t("edit_form.errors.name_contain_specical_character")}</span>
          </div>
          <input
            name="name"
            valid={name.trim() !== ""}
            placeholder={placeholder}
            className="form-control f-18"
            onChange={handleChange}
            value={name}
            maxLength="64"
          />
        </div>
      </div>
    </>
  );
};

export default Toolbar;
